import { Box, FileUpload, FormatByte } from "@chakra-ui/react";
import { LuUpload } from "react-icons/lu";

export default function FileDropZone({
  label = "Upload File",
  accept = ".pdf",
  maxSize = 4000000,
  inputId,
  limit = Number.MAX_VALUE,
  values,
  onChange,
  minHeight,
  height,
}: {
  accept: string[] | string;
  label?: string;
  maxSize?: number;
  inputId: string;
  limit: number;
  values: File[];
  onChange: (values: File[], error?: string) => void;
  minHeight?: string | number;
  height?: string | number;
}) {
  return (
    <FileUpload.Root
      accept={accept}
      alignItems="stretch"
      maxFiles={limit}
      onFileAccept={(detail) => {
        onChange(detail.files, undefined);
      }}
      onFileReject={() => {
        onChange(values, "Invalid file selected");
      }}
    >
      <FileUpload.HiddenInput />
      <FileUpload.Dropzone
        borderWidth={"thin"}
        borderStyle={"dashed"}
        rounded="md"
        minHeight={minHeight}
        height={height}
      >
        {/* Use plain span to avoid Chakra Icon ref-forwarding issue with react-icons */}
        <span style={{ fontSize: "1.5rem", color: "var(--chakra-colors-fg-muted, #888)" }}>
          <LuUpload />
        </span>
        <FileUpload.DropzoneContent>
          <Box>{label}</Box>
          <Box color="fg.muted">
            {accept} up to <FormatByte value={maxSize} unit="byte" />{" "}
          </Box>
        </FileUpload.DropzoneContent>
      </FileUpload.Dropzone>
      <FileUpload.List clearable showSize />
    </FileUpload.Root>
  );
}
